/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Region_Wrist_RInputs */

const en_us2_bodymap_region_wrist_r = /** @type {(inputs: Bodymap_Region_Wrist_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right wrist or hand`)
};

const pt_br2_bodymap_region_wrist_r = /** @type {(inputs: Bodymap_Region_Wrist_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punho ou mão direita`)
};

const es_419_bodymap_region_wrist_r = /** @type {(inputs: Bodymap_Region_Wrist_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muñeca o mano derecha`)
};

const pt_pt2_bodymap_region_wrist_r = /** @type {(inputs: Bodymap_Region_Wrist_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulso ou mão direita`)
};

const fr_fr2_bodymap_region_wrist_r = /** @type {(inputs: Bodymap_Region_Wrist_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poignet ou main droite`)
};

const de_de2_bodymap_region_wrist_r = /** @type {(inputs: Bodymap_Region_Wrist_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtes Handgelenk oder Hand`)
};

const it_it2_bodymap_region_wrist_r = /** @type {(inputs: Bodymap_Region_Wrist_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polso o mano destra`)
};

/**
* | output |
* | --- |
* | "Right wrist or hand" |
*
* @param {Bodymap_Region_Wrist_RInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_region_wrist_r = /** @type {((inputs?: Bodymap_Region_Wrist_RInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Region_Wrist_RInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_region_wrist_r(inputs)
	if (locale === "es-419") return es_419_bodymap_region_wrist_r(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_region_wrist_r(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_region_wrist_r(inputs)
	if (locale === "de-DE") return de_de2_bodymap_region_wrist_r(inputs)
	if (locale === "it-IT") return it_it2_bodymap_region_wrist_r(inputs)
	return en_us2_bodymap_region_wrist_r(inputs)
});
export { bodymap_region_wrist_r as "bodymap.region.wrist_r" }